export class Lotacao {
  constructor({
    id = null,
    local = null,
    codigo = null,
    ehEscola = null,
    gre = null,
    municipio = null,
    ativo = null,
  }) {
    this.id = id;
    this.local = local;
    this.codigo = codigo;
    this.ehEscola = ehEscola;
    this.gre = gre;
    this.municipio = municipio;
    this.ativo = ativo;
  }
  static Build() {
    return new Lotacao({
      id: null,
      local: null,
      codigo: null,
      ehEscola: null,
      gre: null,
      municipio: null,
      ativo: null,
    });
  }
  format() {
    let gre = this.gre.id;
    let municipio = this.municipio.codigo;

    return new Lotacao({
      ...this,
      gre,
      municipio
    });
  }
}
